import { ERROR_VIEW_NAME } from "../core/constants";
import { getViewData, showView } from "../core/views";
import { setErrorViewData } from "../views/ErrorView";

export function showError(name : string) : void {
  const currentError = getViewData(ERROR_VIEW_NAME);
  if (currentError.data?.name) {
    return;
  }
  setErrorViewData(name);
  showView(ERROR_VIEW_NAME);
}

export function hasError() : boolean {
  const currentError = getViewData(ERROR_VIEW_NAME);
  return currentError.data?.name !== undefined;
}
